export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const pageVariants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 }
};

// Clean employee name - remove railroad job codes like "E", "BH", "HBW", "BMR", etc.
export const cleanEmployeeName = (name) => {
  if (!name) return name;
  
  let cleanName = name;
  
  // If name is in format "LASTNAME,(FIRSTNAME)CODES" (railroad raw format - always uppercase)
  const parenMatch = name.match(/^([A-Z]+),\(([A-Z]+)\)/);
  if (parenMatch) {
    const lastName = parenMatch[1];
    const firstName = parenMatch[2];
    cleanName = `${firstName.charAt(0).toUpperCase()}${firstName.slice(1).toLowerCase()} ${lastName.charAt(0).toUpperCase()}${lastName.slice(1).toLowerCase()}`;
  } else if (/[A-Z]{3,}/.test(name) && !/^[A-Z][a-z]+(\s+[A-Z][a-z]+)+$/.test(name.trim())) {
    // Only strip railroad job codes if the name contains uppercase code patterns
    // AND is NOT already a cleanly formatted "Title Case" name like "Coby Pingree".
    // Railroad codes are always UPPERCASE (e.g., "SMITH JOHN BH E", "DOE,(JANE)HBW").
    cleanName = name
      .replace(/\s*\*?[A-Z0-9/]+\s*E\s*$/, '')
      .replace(/\s*\*?BH\s*E?\s*$/, '')
      .replace(/\s*\*?HBW?\s*$/, '')
      .replace(/\s*\*?BMR\s*[A-Z]*\s*$/, '')
      .replace(/\s*\*?DT\s*[0-9/]*\s*$/, '')
      .replace(/\s*\*?ALL\s*$/, '')
      .replace(/\s*\*?RWBH?\s*$/, '')
      .replace(/\s+[A-Z]{1,4}\s*$/, '')
      .replace(/\)[\s\*]*[A-Z0-9\s/]+$/, ')')
      .trim();

    const stillParenMatch = cleanName.match(/^([A-Z]+),\(([A-Z]+)\)$/);
    if (stillParenMatch) {
      const lastName = stillParenMatch[1];
      const firstName = stillParenMatch[2];
      cleanName = `${firstName.charAt(0).toUpperCase()}${firstName.slice(1).toLowerCase()} ${lastName.charAt(0).toUpperCase()}${lastName.slice(1).toLowerCase()}`;
    }
  }
  // Otherwise: name is already clean (e.g., "Coby Pingree") — leave as-is.
  
  return cleanName.trim();
};
